import { Button } from "../ui/button";
import { EllipsisIcon, ListPlusIcon } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { useUserListsCtx } from "~/components/lists/user-lists-provider";

interface AddToListDialogProps {
  id: string;
  type: "OUTFIT" | "OUTFIT_PRODUCT" | "PRODUCT";
}

export const AddToListDropdown = ({ id, type }: AddToListDialogProps) => {
  const { openListDialog } = useUserListsCtx();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="h-10 w-10 rounded-full">
          <EllipsisIcon className="h-5 w-5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuItem onSelect={() => openListDialog({ id, type })}>
          <span className="mr-2.5">
            <ListPlusIcon className="h-4 w-4" />
          </span>
          <span>Add to list</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
